export default "assets/images/icons/slider-arrow-b2b36e7a.svg";